/**
 * Base packing slip / shipment name with "- Box #" suffix removed.
 */
export function getPackingSlipBaseName(name) {
    if (!name || typeof name !== 'string') return '';

    const trimmed = name.trim();
    const match = trimmed.match(/^(.+?)\s-\sBox\s#?\d+$/i);

    return (match ? match[1] : trimmed).trim();
}

export function normalizePackingSlipBaseName(name) {
    return getPackingSlipBaseName(name).toLowerCase();
}

/**
 * Returns conflict info when proposedName matches an existing slip's base name.
 */
export function findPackingSlipBaseNameConflict(proposedName, packingSlips, excludeIds = []) {
    const proposedBase = normalizePackingSlipBaseName(proposedName);
    if (!proposedBase) return null;

    const excludeSet = new Set((excludeIds || []).filter(Boolean));

    for (const slip of packingSlips || []) {
        if (!slip?.name || excludeSet.has(slip.id)) continue;

        if (normalizePackingSlipBaseName(slip.name) === proposedBase) {
            return {
                proposedBaseName: getPackingSlipBaseName(proposedName),
                existingSlip: slip,
                existingBaseName: getPackingSlipBaseName(slip.name)
            };
        }
    }

    return null;
}
